import { render } from "./CollectionsPlayer.vue?vue&type=template&id=34534aef&scoped=true"
import script from "./CollectionsPlayer.vue?vue&type=script&lang=js"
export * from "./CollectionsPlayer.vue?vue&type=script&lang=js"

import "./CollectionsPlayer.vue?vue&type=style&index=0&id=34534aef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34534aef"]])

export default __exports__